import { ReactNode } from 'react'

import * as SC from './styles'

type Props = {
  children: ReactNode
}

export const SidePanelHeader = (props: Props) => {
  const { children } = props

  return (
    <SC.Header title={typeof children === 'string' ? children : undefined}>
      <SC.HeaderInside>{children}</SC.HeaderInside>
    </SC.Header>
  )
}
